import {Stakeholder} from "./Stakeholder.ts";
import {ChartContext} from "./ChartContext.ts";

export class Category {
    constructor(
        private chartContext: ChartContext,
        private name: string,
        private startAngle: number,
        private angleStep: number,
        private stakeholders: Stakeholder[]) {
    }

    draw() {
        const ctx = this.chartContext.ctx;
        const centerX = this.chartContext.centerPosition.x;
        const centerY = this.chartContext.centerPosition.y;
        const maxRadius = this.chartContext.maxRadius;
        const midAngle = this.startAngle + this.angleStep / 2;

        this.drawCategoryLine(ctx, centerX, centerY, maxRadius, this.startAngle);
        this.drawCategoryLabel(ctx, centerX, centerY, maxRadius, midAngle, this.name);
        this.stakeholders.forEach(category => category.draw());
    }

    private drawCategoryLine(ctx: CanvasRenderingContext2D, centerX: number, centerY: number, maxRadius: number, angle: number): void {
        ctx.beginPath();
        ctx.setLineDash([5, 5]);
        ctx.strokeStyle = '#555';
        ctx.lineWidth = 1;
        ctx.moveTo(centerX, centerY);
        ctx.lineTo(
            centerX + maxRadius * Math.cos(angle),
            centerY + maxRadius * Math.sin(angle)
        );
        ctx.stroke();
    }

    private drawCategoryLabel(ctx: CanvasRenderingContext2D, centerX: number, centerY: number, maxRadius: number, angle: number, text: string): void {
        ctx.font = this.chartContext.fontSize + 'px sans-serif';
        ctx.fillStyle = '#FFF';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        const labelRadius = maxRadius + 40;
        ctx.fillText(
            text,
            centerX + labelRadius * Math.cos(angle),
            centerY + labelRadius * Math.sin(angle)
        );
    }
}